import { OrthlyEnvironment } from '@orthly/shared-types';
import { OrthlyBrowserConfig, OrthlyFrontendApps } from '@orthly/ui';

export const ConfigService = new OrthlyBrowserConfig(
    OrthlyFrontendApps.labPortal,
    process.env.REACT_APP_LOCAL_PROD ? OrthlyEnvironment.production : undefined,
);
